import { createAction } from 'redux-act'

import { Profile } from './types'

const fetchProfileStart = createAction('myprofile - fetch profile info start')
const fetchProfileSuccess = createAction<Profile | null>('myprofile - fetch profile info success')
const fetchProfileFail = createAction<Error>('myprofile - fetch profile info')

const updateProfileStart = createAction('myprofile - update profile start')
const updateProfileSuccess = createAction<string>('myprofile - update profile success')
const updateProfileFail = createAction<Error>('myprofile - update profile')

const uploadImageStart = createAction('myprofile - upload image start')
const uploadImageSuccess = createAction<string>('myprofile - upload image success')
const uploadImageFailed = createAction<Error>('myprofile - upload image failed')

const resetImageUploadStatus = createAction('myprofile - reset image upload')
const resetNotifications = createAction('myprofile - reset notifications')
const addNotification = createAction('myprofile - add notification')
export default {
  fetchProfileFail,
  fetchProfileStart,
  fetchProfileSuccess,
  updateProfileFail,
  updateProfileStart,
  updateProfileSuccess,
  uploadImageFailed,
  uploadImageStart,
  uploadImageSuccess,
  addNotification,
  resetImageUploadStatus,
  resetNotifications,
}
